module.exports = "table {\n  max-width: 45em;\n  margin-left: auto;\n  margin-right: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pollresponses/pollresponses.component.scss
// module id = 582
// module chunks = 1